<template>

<!-- Search Filter -->
          <div class="row filter-row">
            <div class="col-sm-6 col-md-3">  
              <div class="form-group form-focus">
                <input type="text" class="form-control floating">
                <label class="focus-label">Employee Name</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-3"> 
              <div class="form-group form-focus select-focus">
                <vue-select :options="assetfilter" />
                <label class="focus-label">Status</label>
              </div>
            </div>
            <div class="col-sm-12 col-md-4">  
               <div class="row">  
                 <div class="col-md-6 col-sm-6">  
                  <div class="form-group form-focus">
                    <div class="cal-icon">
                          <datepicker v-model="startdate"  class="picker1" 
                          :editable="true"
                          :clearable="false" />
                    </div>
                    
                  </div>
                </div>
                 <div class="col-md-6 col-sm-6">  
                  <div class="form-group form-focus">
                    <div class="cal-icon">
                          <datepicker v-model="enddate"  class="picker1" 
                          :editable="true"
                          :clearable="false" />
                    </div>
                    
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-md-2">
              <div class="d-grid">
                <a href="#" class="btn btn-success"> Search </a>  
              </div>  
            </div>     
                    </div>
          <!-- /Search Filter -->
</template>
<script>
   
  
  const currentDate = new Date()
  const currentDate1 = new Date()
  export default {
    data() {
    return {
      assetfilter: ["-- Select -- ", "Pending", "Approved", "Returned"],
      startdate: currentDate,
      enddate: currentDate1,
    }
    },
    components: {
   
    },
    mounted() {
    }
  }
</script>